import {version as appVersion} from '../../../package.json'
import {visualean} from '../../assets/images'
import './styles.css'

const Footer = () => {
  return (
    <div className='footerContainer'>
      <div className='footerCredits'>
        <img src={visualean} className='footerLogoImage' alt='logo' />
        <div className='textLeft'>
          T-ops© copyright {new Date().getFullYear()}
        </div>
      </div>
      <div className='textRight'>v.{appVersion}</div>
    </div>
  )
}

export default Footer
